import { TemplateRef } from '@angular/core';
import { DatoGeograficoCementoVm } from '../../../models/dato-geografico-cemento.vm';
import { AdminServerTableCellContext, AdminServerTableColumn } from '../../../shared/table/models/admin-server-table.model';

interface DatosGeograficosColumnsTemplates {
  actionsCellTemplate: TemplateRef<AdminServerTableCellContext<DatoGeograficoCementoVm>>;
}

export function buildDatosGeograficosCementoColumns(
  templates: DatosGeograficosColumnsTemplates,
): AdminServerTableColumn<DatoGeograficoCementoVm>[] {
  return [
    {
      id: 'codigoRegion',
      header: 'Cód. región',
      sortable: true,
      sortKey: 'codigo_region',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.codigoRegion,
      title: (row) => row.codigoRegion,
    },
    {
      id: 'nombreRegion',
      header: 'Región',
      sortable: true,
      sortKey: 'nombre_region',
      headerClass: 'admin-col-truncate-sm',
      cellClass: 'admin-col-truncate-sm',
      value: (row) => row.nombreRegion,
      title: (row) => row.nombreRegion,
    },
    {
      id: 'codSapProvincia',
      header: 'Cod. SAP prov.',
      sortable: true,
      sortKey: 'cod_sap_provincia',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.codSapProvincia,
      title: (row) => row.codSapProvincia,
    },
    {
      id: 'nombreProvincia',
      header: 'Provincia',
      sortable: true,
      sortKey: 'nombre_provincia',
      headerClass: 'admin-col-truncate-sm',
      cellClass: 'admin-col-truncate-sm',
      value: (row) => row.nombreProvincia,
      title: (row) => row.nombreProvincia,
    },
    {
      id: 'codSapComuna',
      header: 'Cod. SAP comuna',
      sortable: true,
      sortKey: 'cod_sap_comuna',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.codSapComuna,
      title: (row) => row.codSapComuna,
    },
    {
      id: 'nombreComuna',
      header: 'Comuna',
      sortable: true,
      sortKey: 'nombre_comuna',
      headerClass: 'admin-col-truncate-sm admin-col-sticky-left',
      cellClass: 'admin-col-truncate-sm admin-col-sticky-left',
      value: (row) => row.nombreComuna,
      title: (row) => row.nombreComuna,
    },
    {
      id: 'zonaTransporte',
      header: 'Zona transporte',
      sortable: true,
      sortKey: 'zona_transporte',
      headerClass: 'admin-col-truncate-sm',
      cellClass: 'admin-col-truncate-sm',
      value: (row) => row.zonaTransporte,
      title: (row) => row.zonaTransporte,
    },
    {
      id: 'activo',
      header: 'Activo',
      sortable: true,
      sortKey: 'activo',
      cellClass: 'admin-col-center admin-col-nowrap',
      value: (row) => (row.activo ? 'Sí' : 'No'),
    },
    {
      id: 'acciones',
      header: 'Acciones',
      sortable: false,
      headerClass: 'admin-col-actions',
      cellClass: 'admin-col-actions',
      cellTemplate: templates.actionsCellTemplate,
      title: () => '',
    },
  ];
}
